import React, { Component } from "react";
import PropTypes from "prop-types";
import withTranslation from "../../translation";
import { getContext } from "@src/client/context";
import setRsftWelcomeMessageClosed from "./setRsftWelcomeMessageClosed";
import Button from "@src/template/components/Button";
import {
  RSFT_DELIVER_TO_DELIVERY_COUNTRY_REFERRAL_NAME,
  RSFT_DELIVER_ELSEWHERE_REFERRAL_NAME
} from "@src/template/components/WelcomeMessage/RsftWelcomeMessage/constants";

import styles from "../deferred.css";

class RsftWelcomeMessage extends Component {
  state = {
    getTranslations: null,
    userTookAction: false
  };

  async componentDidMount() {
    const getTranslations = (
      await import(/* webpackChunkName: "translations" */ "../../../../../i18n")
    ).default;

    this.setState({
      getTranslations
    });

    this.props.trackImpression();
  }

  handleButtonClick = countryCode => () => {
    const { openCountrySelector } = this.props;
    const RIGHT_SITE_FIRST_TIME_REFERRAL_NAME = countryCode
      ? RSFT_DELIVER_TO_DELIVERY_COUNTRY_REFERRAL_NAME
      : RSFT_DELIVER_ELSEWHERE_REFERRAL_NAME;

    countryCode
      ? openCountrySelector(countryCode, RIGHT_SITE_FIRST_TIME_REFERRAL_NAME)
      : openCountrySelector(undefined, RIGHT_SITE_FIRST_TIME_REFERRAL_NAME);

    setRsftWelcomeMessageClosed();
    this.setState({ userTookAction: true });
  };

  render() {
    const { getTranslations, userTookAction } = this.state;

    if (!getTranslations || userTookAction) {
      return null;
    }

    const {
      formatTranslation,
      country: {
        imageUrl,
        defaultLanguage,
        nameTranslatedToBrowseCountryLocale,
        name: countryName,
        countryCode
      }
    } = this.props;

    const phrasesFromSecondLanguage = getTranslations(defaultLanguage);
    const context = getContext();
    const currentBrowseLanguage = context.getBrowseLanguage();
    const isPrimaryLanguageMatch =
      defaultLanguage.substring(0, 2) === currentBrowseLanguage.substring(0, 2);

    return (
      <div
        className={styles.container}
        role="region"
        aria-labelledby="welcomeMessageText"
        data-testid="welcome-message"
      >
        <div className={styles.mvtWrapper} role="alert" aria-live="assertive">
          <div className={styles.primaryCopyWrapper}>
            <img
              src={imageUrl}
              alt=""
              className={styles.flag}
              data-testid="icon"
            />
            <p className={styles.primaryCopy} id="welcomeMessageText">
              {phrasesFromSecondLanguage[
                "onboarding_web_delivery_country_suggestion_message"
              ].replace("%{geocountry}", countryName)}
            </p>
          </div>
          {!isPrimaryLanguageMatch && (
            <p className={styles.secondaryCopy}>
              {formatTranslation(
                "onboarding_web_delivery_country_suggestion_message",
                {
                  geocountry: nameTranslatedToBrowseCountryLocale
                }
              )}
            </p>
          )}
          <div className={styles.buttonsContainer}>
            <Button
              theme="primary"
              truncateText
              onClick={this.handleButtonClick(countryCode)}
            >
              {formatTranslation(
                "onboarding_web_delivery_country_suggestion_cta_geo",
                {
                  geocountry: nameTranslatedToBrowseCountryLocale
                }
              )}
            </Button>
            <span className={styles.separator}>
              {formatTranslation("delivery_identifier_or")}
            </span>
            <Button
              theme="secondary"
              truncateText
              onClick={this.handleButtonClick()}
            >
              {formatTranslation(
                "onboarding_web_delivery_country_suggestion_cta_other",
                {
                  geocountry: nameTranslatedToBrowseCountryLocale
                }
              )}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

RsftWelcomeMessage.propTypes = {
  formatTranslation: PropTypes.func,
  country: PropTypes.shape({
    countryCode: PropTypes.string.isRequired,
    defaultLanguage: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    nameTranslatedToBrowseCountryLocale: PropTypes.string.isRequired
  }).isRequired,
  redirectUrl: PropTypes.object,
  openCountrySelector: PropTypes.func.isRequired,
  trackImpression: PropTypes.func.isRequired
};

export default withTranslation(RsftWelcomeMessage);
